t = require('views/internal/teacup-with-helpers')('board_menu_commenting')

module.exports = ->
  t.li ->
    t.a '.js-select', { href: '#', name: 'disabled' }, ->
      t.check t.mustacheVar('comments_disabled'), 'disabled'
      t.span '.sub-name', ->
        t.format 'no-one-is-allowed-to-comment'

  t.li ->
    t.a '.js-select', { href: '#', name: 'members' }, ->
      t.check t.mustacheVar('comments_members'), 'members'
      t.span '.sub-name', ->
        t.format 'allow-admins-and-normal-members-to-comment'

  t.li ->
    t.a { href: '#', class: 'js-select' + t.mustacheBlockInverted('comments_showObservers', (-> ' disabled')), name: 'observers' }, ->
      t.check t.mustacheVar('comments_observers'), 'members-and-observers'
      t.span '.sub-name', ->
        t.format 'allow-admins-normal-members-and-observers-to-comment'

  t.li ->
    t.a { href: '#', class: 'js-select' + t.mustacheBlockInverted('orgCanSee', (-> ' disabled')), name: 'org' }, ->
      t.check t.mustacheVar('comments_org'), 'organization-members'
      t.span '.sub-name', ->
        t.format 'allow-admins-normal-members-observers-and-organization-members-to-comment'

  t.li ->
    t.a { href: '#', class: 'js-select' + t.mustacheBlockInverted('permissionLevel_public', (-> ' disabled')), name: 'public' }, ->
      t.check t.mustacheVar('comments_public'), 'any-trello-user'
      t.span '.sub-name', ->
        t.format 'allow-any-trello-member-to-comment'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/board_menu_commenting.coffee